import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["auctionType", "country", "logisticsPricing", "logisticsPricingField"]

  static values = { logisticsPricingCountries: Array }

  static classes = ["hidden"]

  // Timed auctions take no logistics pricing, so a new auction price starts with the setting of its auction type.
  auctionTypeChanged() {
    this.#resetLogisticsPricing()
  }

  // A price in a country without logistics never takes logistics pricing, so the setting is hidden there.
  countryChanged() {
    this.logisticsPricingFieldTarget.classList.toggle(this.hiddenClass, !this.#logisticsPricingOffered)
    this.#resetLogisticsPricing()
  }

  get #logisticsPricingOffered() {
    return this.logisticsPricingCountriesValue.includes(this.countryTarget.value)
  }

  #resetLogisticsPricing() {
    this.logisticsPricingTarget.checked = this.#logisticsPricingOffered && this.auctionTypeTarget.value !== "timed"
  }
}
